export default "__VITE_ASSET__B69LG9wv__"